export default {
    'title': 'Our Offers',
    'subtitle': 'Discover them',
    'all_seasons': 'All',
    'all_offers': 'All offers',
    'details': 'More details',
    'no_offers': 'Momentan nu exista oferte disponibile',
    'write_whatsapp': 'Write us on WhatsApp',
}
